import { useCallback, useEffect, useState } from 'react';
import { listPropertiesForUser } from '../db/repository';
import type { Property } from '../db/types';

export function useProperties(userId: string | null) {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const refresh = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const rows = await listPropertiesForUser(userId);
      setProperties(rows.sort((a, b) => b.updatedAt - a.updatedAt));
    } catch (e) {
      setError(e as Error);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { properties, loading, error, refresh };
}
